import { render, staticRenderFns } from "./IconMenuAlt3Outline.vue?vue&type=template&id=529959aa"
import script from "./IconMenuAlt3Outline.vue?vue&type=script&lang=js"
export * from "./IconMenuAlt3Outline.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports